import React from 'react';
import { PdfHuchaCardContainer2 } from '../../../ui/pdf-hucha-card-container';
import { PdfHuchaBonusCardC2 } from './pdf-hucha-bonus-card-c2';
import { PdfHuchaBonusCardC3 } from './pdf-hucha-bonus-card-c3';

export const PdfHuchaBonusCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PdfHuchaCardContainer2>
			<PdfHuchaBonusCardC2 />
			<PdfHuchaBonusCardC3 dineroHucha={dineroHucha} />
		</PdfHuchaCardContainer2>
	);
};
